import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { loadClinicalSubmittalStatuses,
    loadClinicalSubmittalStatusesSuccess,
    loadClinicalSubmittalStatusesFailed } from '../actions/search-all-clinical-reviews.actions';
import { catchError, mergeMap, of, switchMap } from 'rxjs';
import { ClinicalService } from '../../clinical.service';

@Injectable()
export class SearchAllClinicalReviewsEffects {
    loadClinicalReviewSubmittalStatuses$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(loadClinicalSubmittalStatuses),
            switchMap((action) =>
                this.clinicalService.getClinicalReviewSubmittalStatuses().pipe(
                    mergeMap((response) => [
                        loadClinicalSubmittalStatusesSuccess({
                            clinicalSubmittalStatuses: response
                        })
                    ]),
                    catchError((error: unknown) =>
                        of(
                            loadClinicalSubmittalStatusesFailed({
                                error: 'Failed to get Clinical Submittal Statuses',
                                exception: error
                            })
                        )
                    )
                )
            )
        );
    });

    constructor(
        private readonly actions$: Actions,
        private readonly clinicalService: ClinicalService
    ) {}
}
